import * as React from 'react';
import Dropzone from 'react-dropzone';
import * as FontAwesome from 'react-fontawesome';
import './multiImageDropZone.css';
import { toastr } from 'react-redux-toastr';
import { BeatLoader } from 'react-spinners';

export interface IMultiImageDropZoneState {
  clicked: boolean;
}
export interface IMultiImageDropZoneProps {
  onChange?: (base64: string[]) => void
  loading?: boolean;
  status?: string;
  images?: string[];
}
class MultiImageDropZone extends React.Component<IMultiImageDropZoneProps, IMultiImageDropZoneState> {
  constructor(props: any) {
    super(props);
    this.state = {
      clicked: false,
    }
  }
  public handleDropAccepted = async (files) => {
    const imagesArr = this.props.images ? [...this.props.images] : [];
    for (const file of files) {
      const baseFile = await this.readFile(file);
      imagesArr.push(baseFile)
    }
    if (this.props.onChange) {
      this.props.onChange(imagesArr);
    }
  }
  public handleDropRejected = async () => {
    toastr.error('File type not supported', 'Please select an image with jpg or png extension')
  }
  public readFile(file): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (result) => this.onLoadFile(result, resolve)
    });
  }
  public onLoadFile(result, resolve) {
    const base64 = result.target && result.target.result || ''
    resolve(base64);
  }
  public onStopPropagation = (e) => {
    e.stopPropagation();
  }
  public onDeleteFile = (index) => {
    const imagesArr = this.props.images ? [...this.props.images] : [];
    imagesArr.splice(index, 1);
    if (this.props.onChange) {
      this.props.onChange(imagesArr);
    }
  }
  public render() {
    const { status, images } = this.props;
    const failed = status === "FAILED";
    const success = status === "SUCCESS";
    const uploading = status === "UPLOADING";
    return (
      <div className={`multi-image-dropzone-frame ${failed ? "uploadFailed" : ""}`}>
        <Dropzone disabled={this.props.loading} className="drop-zone-fluid" activeClassName="active" multiple={true} accept="image/jpeg, image/png"
          onDropAccepted={this.handleDropAccepted} onDropRejected={this.handleDropRejected}>
          <div className="thumbnails-container">
            <div className="row">
              {
                (images && images.length > 0) && images.map((image, index) => (
                  <div className="col-md-2" key={index}>
                    <div className="thumbnail" onClick={(event) => this.onStopPropagation(event)}>
                      {
                        !this.props.loading &&
                        <FontAwesome
                          className="delete-icon"
                          name='trash'
                          onClick={() => this.onDeleteFile(index)}
                        />
                      }
                      <img src={image} />
                    </div>
                  </div>
                ))
              }
            </div>
            {
              !uploading && !this.props.loading &&
              <div className="row">
                <FontAwesome name='plus-circle' className="add-icon" />
              </div>
            }
            <div className="status">
              <BeatLoader size={15} color={'#db8733'} loading={uploading} />
              {failed && <i className="fa fa-exclamation-triangle failed" aria-hidden="true" />}
              {success && <i className="fa fa-check-circle success" aria-hidden="true" />}
              {!status}
            </div>
          </div>
        </Dropzone>
      </div>
    )
  }
}

export default MultiImageDropZone;


// WEBPACK FOOTER //
// ./src/share/components/MultiImageDropZone/MultiImageDropZone.tsx